<template>
  <div class="c-status">
    <h2 class="c-title"><span class="c-number">01</span>平均掌握程度</h2>
    <MasteryDegree class=""
          :overallMastery="[data.handout.avg_ability]"/>
    <h2 class="c-title"><span class="c-number">02</span>此知识点学生掌握明细</h2>
    <div class="c-flex">
      <div class="c-left">
        <div class="c-left__header">已掌握（20～100%） {{passed.length}}人</div>
        <div class="c-list">
          <div class="c-item" v-for="(item, i) in passed" :key="i">
            {{item.name}}({{item.ability * 100}} %)
          </div>
        </div>
      </div>
      <div class="c-right">
        <div class="c-right__header">未掌握（0～20%） {{unPassed.length}}人</div>
        <div class="c-list">
          <div class="c-item" v-for="(item, i) in unPassed" :key="i">
            {{item.name}}({{item.ability * 100}} % )
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasteryDegree from '@/components/lodialog-degree.vue';
import _ from 'lodash';

export default {
  name: 'AnalyzeStatus',
  components: {
    MasteryDegree,
  },
  props: {
    data: {},
  },
  computed: {
    passed() {
      const padded = _.get(this.data, 'handout.score_list');
      if (!padded) {
        return [];
      }
      return this.data.handout.score_list;
    },
    unPassed() {
      const lowList = _.get(this.data, 'handout.low_score_list');
      if (!lowList) {
        return [];
      }
      return this.data.handout.low_score_list;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-status {
  .c-title {
    font-size: 17px;
    color: #000;
    margin: 26px;
    display: flex;
    align-items: center;
  }
  .c-flex {
    display: flex;
  }
  .c-left {
    border-right: 1px solid #EBEEF5;
  }
  .c-left,.c-right {
    width: 50%;
  }
  .c-left__header, .c-right__header {
    font-size: 14px;
    color: #050505;
    text-align: center;
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
  .c-left__header {
    background: #F0F2F5;
    border-radius: 4px 0px 0px 4px;
  }
  .c-right__header {
    background: #E0E6F3;
    border-radius: 0px 4px 4px 0px;
  }
  .c-list {
    color: #606266;
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
  }
  .c-item {
    width: 25%;
    height: 48px;
    text-align: center;
    line-height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: nowrap;
    border-bottom: 1px solid #EBEEF5;
  }
  .c-number {
    font-size: 22px;

    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    margin-right: 14px;
    background:url('~@/views/pt/images/class_bg.png');
    background-size:cover;
    width:38px;
    height:29px;
    text-align: center;
    display: inline-block;
  }
}
</style>
